export default "__VITE_ASSET__DNv3Xj2a__"